'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFacebookShareLink = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
/* injects from baggage-loader */

exports.initRemoveNode = initRemoveNode;
exports.initUpdateNodes = initUpdateNodes;
exports.initAddEdge = initAddEdge;
exports.initAddNode = initAddNode;
exports.initDetachNode = initDetachNode;
exports.initRemoveEdge = initRemoveEdge;
exports.initAppendNewNode = initAppendNewNode;
exports.initAppendRightConnectedNode = initAppendRightConnectedNode;
exports.initAppendRightNode = initAppendRightNode;
exports.initAppendBottomConnectedNode = initAppendBottomConnectedNode;
exports.initAddProject = initAddProject;
exports.initProjectSetPermission = initProjectSetPermission;
exports.initDeleteProject = initDeleteProject;
exports.popupWindow = popupWindow;
exports.showProjectShareFBPopup = showProjectShareFBPopup;
exports.initUploadProjectImage = initUploadProjectImage;
exports.initGenerateProjectImage = initGenerateProjectImage;

var _reduxSaga = require('redux-saga');

var _actions = require('./actions');

var _kebakaran = require('kebakaran');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ProjectShareRenderer = require('components/Projects/ProjectShareRenderer');

var _ProjectShareRenderer2 = _interopRequireDefault(_ProjectShareRenderer);

var _s2 = require('utils/s3');

var _pureGraph = require('pure-graph');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initProjectSetPermission, initDeleteProject, initUploadProjectImage, initGenerateProjectImage].map(regeneratorRuntime.mark);

var queryString = require('query-string');

var METAPRO_DOMAIN = 'https://meta.pro';

function getTransactionFunction(transform) {
  return function (data) {
    return (0, _functional.compose)(_pureGraph.convertToIncidentForm, transform, _pureGraph.convertFromIncidentForm)(data || _pureGraph.EMPTY_GRAPH);
  };
}

function getProjectRefs(projectId) {
  var projectRef = (0, _firebase2.default)('projects/' + projectId);
  var graphRef = projectRef.child('graph');
  var nodesDataRef = projectRef.child('nodesData');

  return { projectRef: projectRef, graphRef: graphRef, nodesDataRef: nodesDataRef };
}

function graphTransaction(projectId, transform) {
  var _getProjectRefs = getProjectRefs(projectId);

  var graphRef = _getProjectRefs.graphRef;

  return graphRef.transaction(getTransactionFunction(transform));
}

function pushToNodesData(projectId, data) {
  var _getProjectRefs2 = getProjectRefs(projectId);

  var nodesDataRef = _getProjectRefs2.nodesDataRef;

  return nodesDataRef.push(data).key;
}

function pushToGraph(projectId, data) {
  var _getProjectRefs3 = getProjectRefs(projectId);

  var graphRef = _getProjectRefs3.graphRef;

  return graphRef.push(data).key;
}

function initRemoveNode(projectId, nodeId) {
  var _getProjectRefs4 = getProjectRefs(projectId);

  var nodesDataRef = _getProjectRefs4.nodesDataRef;


  graphTransaction(projectId, (0, _pureGraph.removeNode)(nodeId)).then(function () {
    return nodesDataRef.child(nodeId).remove();
  });
}

function initUpdateNodes(projectId, nodesIds, nodesData) {
  var _getProjectRefs5 = getProjectRefs(projectId);

  var nodesDataRef = _getProjectRefs5.nodesDataRef;


  nodesIds.forEach( //TODO WTF?
  function (id) {
    var _nodesData$id = nodesData[id];
    var caption = _nodesData$id.caption;
    var color = _nodesData$id.color;
    var x = _nodesData$id.x;
    var y = _nodesData$id.y;

    var nodeRef = nodesDataRef.child(id);

    nodeRef.child('caption').set(caption);
    nodeRef.child('color').set(color);
    nodeRef.child('x').set(x);
    nodeRef.child('y').set(y);
  });
}

function initAddEdge(projectId, from, to) {
  var edgeRefKey = pushToGraph(projectId);

  graphTransaction(projectId, (0, _functional.compose)((0, _pureGraph.addEdge)(edgeRefKey, from, to), // second, add the edge
  (0, _pureGraph.removeEdgesToNode)(to) // first, remove all edges to the node
  ));
}

function initAddNode(projectId, nodeData) {
  var nodeRefKey = pushToNodesData(projectId, nodeData);
  graphTransaction(projectId, (0, _pureGraph.addNode)(nodeRefKey));
}

function initDetachNode(projectId, nodeId) {
  graphTransaction(projectId, (0, _pureGraph.removeEdgesIncidentToNode)(nodeId));
}

function initRemoveEdge(projectId, edgeId) {
  graphTransaction(projectId, (0, _pureGraph.removeEdgeWithId)(edgeId));
}

function initAppendNewNode(projectId, _ref) {
  var newNodeData = _ref.newNodeData;
  var id = _ref.id;

  var newNodeId = pushToNodesData(projectId, newNodeData);
  var newEdgeId = pushToGraph(projectId);

  graphTransaction(projectId, (0, _functional.compose)((0, _pureGraph.addEdge)(newEdgeId, id, newNodeId), (0, _pureGraph.addNode)(newNodeId)));
}

function initAppendRightConnectedNode(projectId, _ref2) {
  var newNodeData = _ref2.newNodeData;
  var id = _ref2.id;

  var newNodeId = pushToNodesData(projectId, newNodeData);
  var newEdgeId = pushToGraph(projectId);

  graphTransaction(projectId, function (graphData) {
    var appendedNode = (0, _pureGraph.addNode)(newNodeId, graphData);

    if ((0, _pureGraph.getNodesTo)(id, graphData).length >= 1) {
      // TODO extract to hasNodesTo in pure-graph

      var _getNodesTo = (0, _pureGraph.getNodesTo)(id, graphData);

      var _getNodesTo2 = _slicedToArray(_getNodesTo, 1);

      var parentNodeId = _getNodesTo2[0];


      return (0, _pureGraph.addEdge)(newEdgeId, parentNodeId, newNodeId, appendedNode);
    }

    return appendedNode;
  });
}

function initAppendRightNode(projectId, _ref3) /*, id*/{
  var newNodeData = _ref3.newNodeData;

  var newNodeId = pushToNodesData(projectId, newNodeData);
  graphTransaction(projectId, (0, _pureGraph.addNode)(newNodeId));
}

function initAppendBottomConnectedNode(projectId, _ref4) {
  var newNodeData = _ref4.newNodeData;
  var id = _ref4.id;

  return initAppendNewNode(projectId, { newNodeData: newNodeData, id: id });
}

function initAddProject(userId, project) {
  return new Promise(function (resolve) {
    var data = _extends({}, project, {
      owner: userId,
      deleted: false,
      public: false,
      graph: (0, _pureGraph.convertToIncidentForm)(project.graph)
    });

    var projectRef = (0, _firebase2.default)('projects').push();
    var projectId = projectRef.key;

    require('debug')('metapro:test')(projectId, projectRef);

    // check for `userPermissions/` existence
    (0, _firebase2.default)('userPermissions/').once('value', function (permissionsData) {
      require('debug')('metapro:test')(permissionsData);

      if (!permissionsData) {
        (0, _firebase2.default)('userPermissions/').set(true);
      }

      var permissionsRef = (0, _firebase2.default)('userPermissions/' + userId + '-' + projectId);
      permissionsRef.set({
        user: userId,
        project: projectId
      }, function () {
        return projectRef.set(data);
      });

      resolve(projectId);
    });
  });
}

function initProjectSetPermission(userId, projectId, isPublic, isListed) {
  return regeneratorRuntime.wrap(function initProjectSetPermission$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (isListed) {
            _context.next = 3;
            break;
          }

          _context.next = 3;
          return (0, _reduxSaga.call)(_actions.refSet, '/users/' + userId + '/publicProjects/' + projectId, null);

        case 3:
          _context.next = 5;
          return (0, _reduxSaga.call)(_actions.refSet, '/projects/' + projectId + '/public', isPublic);

        case 5:
          if (!isListed) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return (0, _reduxSaga.call)(_actions.refSet, '/users/' + userId + '/publicProjects/' + projectId, true);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function initDeleteProject(project) {
  var _sagaCbLoose, listener, callback, permissions;

  return regeneratorRuntime.wrap(function initDeleteProject$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCbLoose.listener;
          callback = _sagaCbLoose.callback;
          _context2.next = 5;
          return (0, _reduxSaga.call)(_actions.refSet, '/projects/' + project.id + '/deleted', true);

        case 5:
          (0, _firebase2.default)('userPermissions').orderByChild('project').equalTo(project.id).once('value', listener);
          _context2.next = 8;
          return (0, _reduxSaga.cps)(callback);

        case 8:
          permissions = _context2.sent;

          _lodash2.default.each(permissions.val(), function (permission) {
            var userId = permission.user;
            var projectId = permission.project;
            (0, _firebase2.default)('/userPermissions/' + userId + '-' + projectId).remove();
          });
          _context2.next = 12;
          return (0, _reduxSaga.call)(_actions.refRemove, '/users/' + project.owner + '/publicProjects/' + project.id);

        case 12:
          _context2.next = 14;
          return (0, _reduxSaga.call)(_actions.refRemove, '/projects/' + project.id);

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

// Sharing
function popupWindow(url, title, w, h) {
  var _window$screen = window.screen;
  var width = _window$screen.width;
  var height = _window$screen.height;


  var left = width / 2 - w / 2;
  var top = height / 2 - h / 2;
  return window.open(url, title, 'toolbar=no, location=no, directories=no, ' + 'status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, ' + ('width=' + w + ', height=' + h + ', top=' + top + ', left=' + left));
}

function showProjectShareFBPopup(url) {
  popupWindow(url, 'Share on Facebook', 600, 600);
}

/* eslint camelcase:0 */
var getFacebookShareLink = exports.getFacebookShareLink = function getFacebookShareLink(_ref5) {
  var projectId = _ref5.projectId;
  var /*userId,*/projectTitle = _ref5.projectTitle;
  var projectImageUrl = _ref5.projectImageUrl;

  var projectShareLink = METAPRO_DOMAIN + '/project/' + projectId;

  var shareQuery = queryString.stringify({
    app_id: '1549614872020223',

    display: 'popup',
    name: projectTitle,
    redirect_uri: METAPRO_DOMAIN,
    link: projectShareLink,
    picture: projectImageUrl,
    caption: 'My project at metapro',
    description: 'I\'ve made a mindmap at meta.pro and I\'m sharing it with you.',
    ref: 'metapro'
  });

  var facebookShareLink = 'https://www.facebook.com/dialog/feed?' + shareQuery;

  return facebookShareLink;
};

function initUploadProjectImage(_ref6) {
  var projectId = _ref6.projectId;
  var base64Data = _ref6.base64Data;
  return regeneratorRuntime.wrap(function initUploadProjectImage$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt('return', (0, _s2.uploadProjectImage)({ projectId: projectId, base64Data: base64Data }));

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function initGenerateProjectImage(_ref7) {
  var userName = _ref7.userName;
  var /*userId,*/project = _ref7.project;
  var projectTitle;
  return regeneratorRuntime.wrap(function initGenerateProjectImage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          // const projectId = project.id;
          projectTitle = project.name;

          // generate the image

          return _context4.abrupt('return', (0, _ProjectShareRenderer2.default)({
            project: project, authorName: userName, projectTitle: projectTitle,
            width: 1200,
            height: 630
          }));

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/projectActions.js
// module id = 230
// module chunks = 1